export type CliVersionStatus = 'match' | 'patch-behind' | 'diverged'

function parseSemver(version: string): [number, number, number] | null {
  const match = version.match(/^(\d+)\.(\d+)\.(\d+)/)
  if (!match) return null
  return [Number(match[1]), Number(match[2]), Number(match[3])]
}

// Compares an installed Claude Code CLI version against the latest
// published version (#865). `null` when either side is unknown — nothing
// to compare yet, rendered as a neutral state rather than a color.
//
// - 'match': installed exactly equals latest.
// - 'patch-behind': same major.minor, installed patch is lower.
// - 'diverged': any other difference — behind on major/minor, OR ahead of
//   latest in any way (installed should never legitimately be ahead, so
//   that's treated the same as being meaningfully behind).
export function compareCliVersions(installed: string | null, latest: string | null): CliVersionStatus | null {
  if (!installed || !latest) return null

  const i = parseSemver(installed)
  const l = parseSemver(latest)
  if (!i || !l) return null

  const [iMajor, iMinor, iPatch] = i
  const [lMajor, lMinor, lPatch] = l

  if (iMajor === lMajor && iMinor === lMinor) {
    if (iPatch === lPatch) return 'match'
    if (iPatch < lPatch) return 'patch-behind'
  }
  return 'diverged'
}
